export default __webpack_public_path__ + "b9608cc8b5658a0ba3134e8f5d85575c.png";